import { ITelemetryProperties } from '@fluidframework/common-definitions';

interface LoggingHeader {
  headerName: string;
  logName: string;
}

/** We rename headers so that otel doesn't scrub them away. Otel doesn't allow certain characters in headers including '-' */
const headersToLog: LoggingHeader[] = [
  { headerName: 'sprequestguid', logName: 'spRequestGuid' },
  { headerName: 'request-id', logName: 'requestId' },
  { headerName: 'client-request-id', logName: 'clientRequestId' },
  { headerName: 'x-msedge-ref', logName: 'xMsedgeRef' }
];

/**
 * Extracts value of known diagnostic headers returned with Graph and ODSP fetch response.
 * @param response Fetch response to process
 */
export function getOdspAndGraphRequestIdsFromResponse(response: Response): ITelemetryProperties {
  const additionalProps: ITelemetryProperties = {};
  if (response && response.headers) {
    headersToLog.forEach((header) => {
      const headerValue = response.headers.get(header.headerName);
      if (headerValue) {
        additionalProps[header.logName] = headerValue;
      }
    });
  }
  return additionalProps;
}
